export function isAutomaticReview(reviewer) {
    return reviewer === '0';
}
